module.exports = __webpack_public_path__ + "static/media/pins_alert.64d0a4f7.png";